import { useRef, useState } from 'react';
import { isUnsupportedRom, UNSUPPORTED_EXTS, fileExtLower } from '../lib/romUtils.js';
import { ConsoleCartPreview } from './ConsoleCartPreview.jsx';
import { InstallAppButton } from './InstallAppButton.jsx';
import { RomLibrary } from './RomLibrary.jsx';

export function LibraryPage({
  groups,
  libraryLoading,
  searchTerm,
  onSearchChange,
  onSelectGame,
  onDownloadRom,
  downloadingVaultId,
  favoriteGames = [],
  onLoadFile,
  padStatus,
  padCount,
  onWakeGamepad,
  profileStatus,
  romStatus,
  onExit,
}) {
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(null);

  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (isUnsupportedRom(f.name)) {
      onLoadFile(null, `${UNSUPPORTED_EXTS[fileExtLower(f.name)]} não suportado: ${f.name}`);
      e.target.value = '';
      return;
    }
    onLoadFile(f);
    e.target.value = '';
  };

  const totalShown = groups.reduce((n, g) => n + g.games.length, 0);

  return (
    <div className="arcade-floor">
      <div className="cabinet cabinet--library">
        <div className="cabinet-body cabinet-body--library">
          <aside className="cabinet-side cabinet-side--left">
            <span className="side-bolt" aria-hidden="true" />
            <ConsoleCartPreview game={preview?.game} ejsKey={preview?.ejsKey} />
            <div className="stickers" aria-hidden="true">
              <span>★ SELECT ★</span>
              <span>PRESS START</span>
            </div>
          </aside>

          <main className="cabinet-main cabinet-main--library">
            <div className="crt-bezel crt-bezel--library">
              <div className="crt-inner crt-inner--library">
                <div className="library-control-deck">
                  <div className="coin-slot" aria-hidden="true">
                    <span className="coin-slot-bar" />
                    <span className="coin-slot-bar" />
                  </div>
                  <div className="rom-search library-search">
                    <input
                      type="search"
                      placeholder="Pesquisar jogos…"
                      aria-label="Pesquisar jogos"
                      autoComplete="off"
                      value={searchTerm}
                      onChange={(e) => onSearchChange(e.target.value)}
                    />
                    <span className="rom-search__count">
                      {!libraryLoading && totalShown > 0
                        ? searchTerm
                          ? `${totalShown} encontrados`
                          : `${totalShown} jogos`
                        : ''}
                    </span>
                  </div>
                    <label className="rom-file-btn library-upload">
                      <input
                        ref={fileRef}
                        type="file"
                        accept=".zip,.bin,.gen,.md,.smd,.nes,.smc,.gba,.gb,.gbc,.nds,.iso,.cue,.3ds,.cci,.cia,.wbfs,.wad,.gcm,.gc,.rvz,.ciso,.a26"
                        hidden
                        onChange={handleFile}
                      />
                      ROM local
                    </label>
                    {onExit && (
                      <button type="button" className="rom-file-btn library-upload" onClick={onExit} style={{ marginLeft: '10px' }}>
                        Voltar
                      </button>
                    )}
                  </div>

                <RomLibrary
                  groups={groups}
                  favoriteGames={favoriteGames}
                  loading={libraryLoading}
                  searchTerm={searchTerm}
                  onSelectGame={onSelectGame}
                  onPreviewGame={(game, ejsKey) => setPreview({ game, ejsKey })}
                  onDownloadRom={onDownloadRom}
                  downloadingVaultId={downloadingVaultId}
                  fullPage
                />
              </div>
            </div>

            {(romStatus || padStatus || profileStatus) && (
              <div className="library-deck-status">
                {romStatus ? <p className="library-status">{romStatus}</p> : null}
                {profileStatus ? <p className="profile-status">{profileStatus}</p> : null}
                <p className={`pad-status${padCount ? ' pad-status--ok' : ''}`}>{padStatus}</p>
              </div>
            )}

          </main>

          <aside className="cabinet-side cabinet-side--right">
            <span className="side-bolt" aria-hidden="true" />
            <InstallAppButton className="install-app--side" />
            <div className="vol-knob" aria-hidden="true" title="Volume" />
            <button type="button" className="btn-pad-wake btn-pad-wake--arcade" onClick={onWakeGamepad}>
              Detetar comando
            </button>
          </aside>
        </div>

        <div className="cabinet-feet" aria-hidden="true">
          <div className="foot" />
          <div className="foot" />
        </div>
      </div>
    </div>
  );
}
